import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const USER_NOTIFICATIONS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('USER_NOTIFICATIONS');
export const USER_NOTIFICATIONS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	USER_NOTIFICATIONS_CRUD_ACTION_CONSTANTS
);
